import { ShoppingBagIcon } from '@heroicons/react/24/outline';
import React from 'react';

export const CheckoutButton = ({ 
    text = "Checkout", 
    onClick, 
    disabled = false, 
    className = "", 
    size = "medium",
    variant = "primary" 
}) => {
    const sizeClasses = {
        small: "px-4 py-2 text-sm",
        medium: "px-6 py-3 text-base",
        large: "px-8 py-4 text-lg"
    };

    const variantClasses = {
        primary: "bg-gradient-to-r from-purchase-color to-purchase-color hover:from-purchase-color hover:to-purchase-color-hover text-black shadow-lg hover:shadow-xl",
        secondary: "bg-gradient-to-r from-orange-100 to-orange-200 hover:from-orange-200 hover:to-orange-300 text-orange-800 border border-orange-300",
        outline: "border-2 border-orange-400 text-orange-600 hover:bg-orange-50 hover:border-orange-500"
    };

    const disabledClasses = "bg-gray-200 text-gray-400 cursor-not-allowed hover:shadow-lg";

    return (
        <button
            onClick={onClick}
            disabled={disabled}
            className={`
                relative overflow-hidden rounded-lg transition-all duration-200 ease-in-out
                transform hover:scale-105 active:scale-95
                ${sizeClasses[size]}
                ${disabled ? disabledClasses : variantClasses[variant]}
                ${className}
            `}
        >
            

            {/* Button Content */}
            <div className="relative z-10 flex items-center justify-center space-x-2">
                <ShoppingBagIcon className="w-6 h-6"/>
                <span>{text}</span>
            </div>

            {/* Shine Effect */}
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white to-transparent opacity-0 hover:opacity-20 transform -skew-x-12 -translate-x-full hover:translate-x-full transition-all duration-700 ease-out"></div>
        </button>
    );
};

export default CheckoutButton;
